// bao migrate skip
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-toolbar2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import guid from "../../factories/guid";
import BaoRouter from "./../../services/bao-router";

class ConfigurationItem100QualificationDialog {
    Bao = Bao;
    Dialog: BaoDialog;
    ConfigurationItemId = ko.observable();
    QualificationItem = ko.observable<any>();
    QualificationId: KnockoutObservable<string>;
    QualificationName = ko.observable();
    ValidFromJs = ko.observable<any>();
    ValidToJs = ko.observable<any>();
    ValidFrom = ko.observable<any>();
    ValidTo = ko.observable<any>();
    QualificationTypeId: KnockoutObservable<string> = null;
    QualificationTypeName = ko.observable();
    QualificationDescription = ko.observable();
    public QualificationType: KnockoutObservable<any> = ko.observable<any>();
    IsDefault = ko.observable();
    ExpirationEnabled = ko.observable(false);
    Parent:any;

    /**
     * Reference id of Configuration item documents uploaded on table ConfigurationItemReferenceDocument
     */
    ConfigurationItemReferenceDocumentId = ko.observable();
    ConfigurationItemReferenceDocumentClass = ko.observable();
    ConfigurationItemReferenceDocumentMetaData = ko.observable();
    ConfigurationItemReferenceDocumentName = ko.observable();

    /**
     * Checks if certificate upload required from QualificationType
     */
    CertificateUploadRequired = ko.observable(false);

    PageIndex = ko.observable<number>(0);
    PageSize = ko.observable<number>(10);
    Sorting = ko.observableArray<any>();
    private _msgCancel = Bao.Session.GetMessage("msgCancel");
    private _msgOk = Bao.Session.GetMessage("msgOk");

    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        $.extend(this, data);
        data.Parent.ItemCompleteCheck = this.ItemCompleteCheck;
        this.Parent = data.Parent;
    }
    SearchQualificationType = {
        ObjectId: this.QualificationTypeId,
        SelectedItem: this.QualificationType,
        ObjectValue: 'Name',
        SearchType: 'QualificationType',
        AutoComplete: true,
        AutoSearch: true
    };
    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        let def = $.Deferred<boolean>();
        let result = true;
        let dateResult = true;
        if (Bao.Utils.String.IsNullOrWhitespace(this.QualificationId())) {
            result = false;
        }
        if (this.ExpirationEnabled()) {
            if (Bao.Utils.String.IsNullOrWhitespace(this.ValidFromJs()) || Bao.Utils.String.IsNullOrWhitespace(this.ValidToJs())) {
                result = false;
            }
        }
        if(this.CertificateUploadRequired() && Bao.Utils.String.IsNullOrWhitespace(this.ConfigurationItemReferenceDocumentId())){
            result = false;
        }        
        if (!result) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        if (this.ExpirationEnabled()) {
            if (this.ValidToJs() < this.ValidFromJs()) {
                dateResult = false;
            }
            if (!dateResult) {
                {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("Invalid_Date_Message"), "info");
                    def.resolve(dateResult);
                }
            }
        }
        def.resolve(result);
        return def.promise();
    };
    loaded() {
        this.QualificationType.subscribe((newValue) => this.UpdateQualificationTpe(newValue));
        this.QualificationItem.subscribe(() => {
            this.UpdateQualificationDescription();
        });
    }
    UpdateQualificationDescription() {
        if (this.QualificationItem() != null) {
            this.QualificationDescription(this.QualificationItem().Description);
        }
    }
    UpdateQualificationTpe(newValue) {
        this.CertificateUploadRequired(newValue.CertificateUploadRequired);
        if (newValue) {
            this.QualificationTypeId(newValue.QualificationTypeId);
            if (newValue.ExpirationEnabled) {
                this.ExpirationEnabled(true);
            }
            else {
                this.ExpirationEnabled(false);
                this.ValidFromJs(null);
                this.ValidToJs(null);
            }
        }
        else {
            this.ValidFromJs(null);
            this.ValidToJs(null);
            this.ExpirationEnabled(false);
            this.QualificationTypeId(null);
            this.CertificateUploadRequired(false);
        }
    }

    /**
     * initialize document upload dialog data
     * @returns DocumentDialog
     */
    InitializeDialogs() {
        let documentDialog = new BaoDialog(Bao.Session.ApplicationName);
        documentDialog.Width("450px");
        documentDialog.Buttons([
            new BaoDialog.ButtonFactory(documentDialog, this._msgOk, () => {
                if (!Bao.Utils.String.IsNullOrWhitespace(documentDialog.ViewModel().DocumentName()) &&
                    !Bao.Utils.String.IsNullOrWhitespace(documentDialog.ViewModel().Class())) {
                    documentDialog.IsLoading(true);
                    let item = documentDialog.ViewModel();
                    let isEdit = item.IsEdit;
                    $.when(documentDialog.ViewModel().Upload()).then(() => {
                        let defs = [];
                        ko.utils.arrayForEach(item.DocumentIds(), (id, index) => {
                            let viewModel = ko.map.toJS(item);
                            viewModel.ConfigurationItemReferenceDocumentId = id;
                            viewModel.PrimaryKeyValue = id;
                            viewModel.SimpleSearchId = id;
                            if (isEdit) {
                                viewModel.DocumentName = ko.unwrap(item.DocumentName);
                            }
                            else {
                                viewModel.DocumentName = viewModel.SelectedFiles[index];
                            }

                            this.ConfigurationItemReferenceDocumentId(viewModel.ConfigurationItemReferenceDocumentId);
                            this.ConfigurationItemReferenceDocumentClass(viewModel.Class);
                            this.ConfigurationItemReferenceDocumentMetaData(viewModel.MetaData);
                            this.ConfigurationItemReferenceDocumentName(viewModel.DocumentName);
                        });
                        $.when.apply(this, defs).then(() => {
                            documentDialog.IsLoading(false);
                            documentDialog.Close();
                        });
                    });
                }
                else {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            }),
            new BaoDialog.ButtonFactory(documentDialog, this._msgCancel, 
                () => { 
                    documentDialog.Close(); 
                    this.Parent.TabPage.DirtyFlag(false); 
                })
        ]);
        return documentDialog;
    }
    
    /**
     * Opens document upload dialog
     * @returns Void
     */
    ShowConfigurationItemReferenceDocumentDialog(){
        let documentDialog: BaoDialog = this.InitializeDialogs();
        return Bao.post("ConfigurationItemTab/ShowConfigurationItemReferenceDocumentDialog", JSON.stringify({
            sessionTabId: this.Parent.SessionTabId,
            configurationItemId: this.ConfigurationItemId(),
            configurationItemReferenceDocumentId: this.ConfigurationItemReferenceDocumentId()
        }), (value: any) => {
            this.SetUploadedDocumentsToDialog(value, documentDialog);
        });
    }

    /**
     * Method for document download
     */
    DownloadConfigurationItemReferenceDocument() {
        BaoRouter.setHash("document/" + this.ConfigurationItemReferenceDocumentId());
    }

    /**
     * Method to set uploaded documents in document dialog
     * @param value 
     */
    SetUploadedDocumentsToDialog(value: any, documentDialog: BaoDialog){
        let viewModel = ko.map.fromJS(value.Model);
            viewModel.Upload = function () { };
            viewModel.SelectedFiles = ko.observableArray<string>();
            viewModel.IsEdit = this.ConfigurationItemReferenceDocumentId() != null;
            viewModel.DocumentType = ko.observable(0); // sets the document type to file
            viewModel.SelectedFiles.subscribe((newIds) => {
                let ids = [viewModel.ConfigurationItemReferenceDocumentId()];
                if (newIds != null) {
                    ko.utils.arrayForEach(newIds, (id, index) => {
                        if (index > 0) {
                            ids.push(guid());
                        }
                    });
                }
                viewModel.DocumentIds(ids);
            });
            viewModel.DocumentIds = ko.observableArray<string>();
            if (viewModel.IsEdit) {
                viewModel.DocumentIds([this.ConfigurationItemReferenceDocumentId()]);
            }
            viewModel.UploadUrl = ko.computed(() => {
                const documentId = viewModel.DocumentIds().join(';');
                return 'ConfigurationItemTab/UploadReferenceDocument?configurationItemReferenceDocumentIds=' + documentId;
            });
            documentDialog.ViewModel(viewModel);
            documentDialog.Template(value.Message);
            documentDialog.Open();
    }
}
export default ConfigurationItem100QualificationDialog;